import { render, staticRenderFns } from "./eod-workflow-mail-config.vue?vue&type=template&id=d374ad64"
import script from "./eod-workflow-mail-config.vue?vue&type=script&lang=js"
export * from "./eod-workflow-mail-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports